import React, { useState, useEffect } from "react";
import AddnExport from "../sub-components/Add-Export";
import DataTable from "react-data-table-component";
import { ActivePill, InactivePill } from "../sub-components/StatusPill";
import Search from "../sub-components/Search";
import { useNavigate } from "react-router-dom";
import TableActions from "../sub-components/TableActions";
import { StockService } from "../../../../services/StockService";
import moment from "moment";
import swal from "sweetalert";
import toast from "react-hot-toast";
const Compartments = () => {
  const navigate=useNavigate()
  const compartmentColumns = [
    {
      name: "Compartment Number",
      selector: (row) => row.compartmentName,
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
    {
      name: "No. of Trees",
      selector: (row) => row.numberOfTrees,
    },
    {
      name: "Active",
      selector: (row) => row.isActive?<ActivePill >Active</ActivePill>:<InactivePill>Inactive</InactivePill>,
  
    },
    {
      name: "Date",
      selector: (row) => moment(row.dateCreated).format('yyyy-MM-DD'),
    },
    {
      name:'Actions',
      selector:(row)=><div>
        <TableActions viewAction={()=>navigate(`${row.compartmentId}`)} deleteAction={()=>deleteRow(row)} />
      </div>
    }
  ];
  const [pending, setPending] = useState(true);
  const [compactments,setCompactments] = useState([])
  const deleteRow = (row) => {
    swal({
      title: "Delete this compartment?",
      text: `${row.compartmentName} will be removed permanently. The server refuses if records that use it still exist.`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmed) => {
      if (!confirmed) return;
      StockService.RemoveCompartment(row.compartmentId).then((res) => {
        if (res.Successful) {
          toast.success(res.message || "Compartment deleted");
          setCompactments((rows) => rows.filter((r) => r.compartmentId !== row.compartmentId));
        } else {
          toast.error(res.message, { duration: 8000 });
        }
      });
    });
  };
 
  useEffect(() => {
  handleCompactments();
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

   

    const handleCompactments = () => {
      StockService.GetAllCompactments().then((res) => {
        
        setCompactments(...compactments, res);
        setPending(false);
        // console.log(concessions)
        
      });
    };

const [search] = useState("");
  return (
    <div className="w-full">
      <AddnExport />
      <Search/>
      <DataTable
        className="w-full rounded rounded-lg"
        columns={compartmentColumns}
        data={compactments.filter((item) => {
          if (search === "") {
            return item;
          } else{
           return item.description.toLowerCase().includes(search.toLowerCase())||
           item.compartmentName.toLowerCase().includes(search.toLowerCase())
           
          }
          })}
        progressPending={pending}
        pagination
      />
    </div>
  );
};

export default Compartments;
